<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M16.3399 8.16975V13.6851C16.3399 14.4165 16.0494 15.1179 15.5322 15.6351C15.0151 16.1523 14.3136 16.4428 13.5823 16.4428H9.72151C9.57523 16.4428 9.43495 16.3847 9.33151 16.2813C9.22808 16.1778 9.16997 16.0375 9.16997 15.8913C9.16997 15.745 9.22808 15.6047 9.33151 15.5013C9.43495 15.3978 9.57523 15.3397 9.72151 15.3397H13.5823C14.0211 15.3397 14.442 15.1654 14.7523 14.8551C15.0626 14.5448 15.2369 14.1239 15.2369 13.6851H13.5823C13.1434 13.6851 12.7226 13.5108 12.4123 13.2005C12.102 12.8902 11.9277 12.4693 11.9277 12.0305V9.27282C11.9277 8.83399 12.102 8.41313 12.4123 8.10283C12.7226 7.79253 13.1434 7.61821 13.5823 7.61821H15.2127C15.1084 6.47166 14.6799 5.37848 13.9774 4.46635C13.275 3.55422 12.3274 2.8608 11.2456 2.46709C10.1637 2.07338 8.99211 1.99562 7.86769 2.24291C6.74327 2.4902 5.71243 3.05233 4.89557 3.86363C3.87981 4.86598 3.25331 6.19668 3.12789 7.61821H4.75768C5.19651 7.61821 5.61737 7.79253 5.92767 8.10283C6.23797 8.41313 6.41229 8.83399 6.41229 9.27282V12.0305C6.41229 12.4693 6.23797 12.8902 5.92767 13.2005C5.61737 13.5108 5.19651 13.6851 4.75768 13.6851H3.65461C3.21578 13.6851 2.79492 13.5108 2.48462 13.2005C2.17432 12.8902 2 12.4693 2 12.0305V8.16975C2.00155 6.74947 2.42442 5.36158 3.21511 4.18174C4.00579 3.00191 5.12873 2.08317 6.44179 1.54183C7.75485 1.00048 9.19901 0.860863 10.5915 1.14064C11.9839 1.42042 13.262 2.10702 14.2641 3.11354C14.9257 3.77835 15.4496 4.56717 15.8058 5.43481C16.162 6.30244 16.3435 7.23184 16.3399 8.16975Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'CustodianSupportIconFilled18'
};
</script>

<style scoped>

</style>